import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  getClientInvoiceListService,
  getClientInvoiceService,
  getClientListService,
  updateClientAdminService,
  updateClientInvoiceService,
} from 'services/client.service';

import {
  GetClientInvoiceListProps,
  GetClientInvoiceProps,
  UpdateClientAdminProps,
  UpdateClientInvoiceProps,
} from 'entities/Client';

export const getClientList = createAsyncThunk(
  'client/list',
  async (_, thunkApi) => {
    try {
      const response = await getClientListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getClientInvoiceList = createAsyncThunk(
  'client/invoiceList',
  async (data: GetClientInvoiceListProps, thunkApi) => {
    try {
      const response = await getClientInvoiceListService(data);

      return response.data;
    } catch (error: unknown) {
      throw thunkApi.rejectWithValue(error);
    }
  }
);

export const getClientInvoice = createAsyncThunk(
  'client/invoice',
  async (data: GetClientInvoiceProps, thunkApi) => {
    try {
      const response = await getClientInvoiceService(data);

      return response.data;
    } catch (error: unknown) {
      throw thunkApi.rejectWithValue(error);
    }
  }
);

export const updateClientInvoice = createAsyncThunk(
  'client/updateInvoice',
  async (data: UpdateClientInvoiceProps, thunkApi) => {
    try {
      const response = await updateClientInvoiceService(data);

      return response.data;
    } catch (error: unknown) {
      throw thunkApi.rejectWithValue(error);
    }
  }
);

export const updateClient = createAsyncThunk(
  'client/update',
  async (data: UpdateClientAdminProps, thunkApi) => {
    try {
      const response = await updateClientAdminService(data);

      return response.data;
    } catch (error: unknown) {
      throw thunkApi.rejectWithValue(error);
    }
  }
);
